import { addParametersToContentfulUrl } from 'utils/addParametersToContentfulUrl'
import { useState, useEffect } from 'react'

export type PostImageType = {
  fields: {
    file: {
      url: string
      details: {
        image: {
          width: number
          height: number
        }
      }
    }
    title: string
  }
  sys?: {
    createdAt: string
    updatedAt: string
  }
}

type PostImageProps = {
  content: PostImageType
}

export const PostImage = ({ content }: PostImageProps) => {
  const [isMobile, setIsMobile] = useState<boolean>(true)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600)

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (!content?.fields?.file) return null

  const mobileImageWidth = {
    name: 'w',
    value: '500',
  }

  const parameters = [
    { name: 'fm', value: 'webp' },
    { name: 'q', value: '90' },
    ...(isMobile ? [mobileImageWidth] : []),
  ]
  return (
    <img
      // @ts-ignore - fetchPriority is a valid HTML attribute but not yet in React types
      fetchPriority="high"
      src={`https:${addParametersToContentfulUrl(content.fields.file.url, parameters)}`}
      alt={content.fields.title}
    />
  )
}
